module.exports = __webpack_public_path__ + "static/img/szafa_9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_9.jpg
// module id = JSB2
// module chunks = 0